import { State } from 'modules';

export const allOrganizations = (state: State) =>
  state.superAdmin.allOrganizations;

export const allOrganizationsLoaded = (state: State) =>
  state.superAdmin.allOrganizationsLoaded;

export const loadAllOrganizationsPending = (state: State) =>
  state.superAdmin.loadAllOrganizationsPending;

export const selectedOrganizationId = (state: State) =>
  state.superAdmin.selectedOrganizationId;

export const orgStats = (state: State) => state.superAdmin.orgStats;

export const loadOrgStatsPending = (state: State) =>
  state.superAdmin.loadOrgStatsPending;

export const orgUsage = (state: State) => state.superAdmin.orgUsage;

export const loadOrgUsagePending = (state: State) =>
  state.superAdmin.loadOrgUsagePending;

export const orgCredit = (state: State) => state.superAdmin.orgCredit;

export const orgPlans = (state: State) => state.superAdmin.orgPlans;

export const loadOrgCreditPending = (state: State) =>
  state.superAdmin.loadOrgCreditPending;

export const setOrgCreditPending = (state: State) =>
  state.superAdmin.setOrgCreditPending;

export const disableOrgPending = (state: State) =>
  state.superAdmin.disableOrgPending;
